<template>
  <div>
    <vxe-grid
      ref="payStatementTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      row-id="shipmentPayStatementCode"
      row-config.keyField
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        checkMethod: checCheckboxkMethod,
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="onCellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:append="{ row }">
        <el-tag size="mini" :type="row.isAppend === 'Y' ? '' : 'info'">
          {{ row.v_isAppend }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentPayStatementStatus === 'D' ||
            row.shipmentPayStatementStatus === 'R'
              ? 'danger'
              : row.shipmentPayStatementStatus === 'S'
              ? 'warning'
              : row.shipmentPayStatementStatus === 'Y'
              ? 'success'
              : row.shipmentPayStatementStatus === 'W'
              ? ''
              : ''
          "
        >
          {{ row.v_shipmentPayStatementStatus }}
        </el-tag>
      </template>
      <template v-slot:currencyTotalAmount="{ row }">
        <span
          >{{ row.v_currencyTotalAmount || 0 }}
          {{ row.v_currencyUnit || '' }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { code: row.shipmentPayStatementCode },
                  query: { shipmentPayStatementNo: row.shipmentPayStatementNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="
              allow('M') &&
                (row.shipmentPayStatementStatus === 'W' ||
                  row.shipmentPayStatementStatus === 'R')
            "
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { code: row.shipmentPayStatementCode },
                  query: { shipmentPayStatementNo: row.shipmentPayStatementNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="
              allow('D') &&
                (row.shipmentPayStatementStatus === 'W' ||
                  row.shipmentPayStatementStatus === 'R')
            "
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_submitReview') || '提交审核'"
            placement="top"
            v-if="
              allow('S') &&
                (row.shipmentPayStatementStatus === 'W' ||
                  row.shipmentPayStatementStatus === 'R')
            "
          >
            <i
              class="el-icon-check tool-btn"
              @click="$emit('submitReview', row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_appendCost') || '追加费用'"
            placement="top"
            v-if="
              allow('T') &&
                row.shipmentPayStatementStatus === 'Y' &&
                row.isAppend === 'N'
            "
          >
            <i
              class="el-icon-circle-plus-outline tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'append',
                  params: { code: row.shipmentPayStatementCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-if="allow('P')"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="copy(row.shipmentPayStatementCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ shipmentPayStatementCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .shipmentPayStatementDelApi({ shipmentPayStatementCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckBoxRow() {
      this.$refs.payStatementTable.clearCheckboxRow()
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return
      this.$refs.payStatementTable.toggleCheckboxRow(row)
      const data = this.$refs.payStatementTable.getCheckboxRecords(true)
      this.$emit('checkbox-change', data)
    },
    clearCheckboxRows() {
      this.$refs.payStatementTable.removeCheckboxRow()
    },
    checCheckboxkMethod({ row }) {
      return (
        row.shipmentPayStatementStatus === 'W' ||
        row.shipmentPayStatementStatus === 'R'
      )
    },
    copy(shipmentPayStatementCode) {
      this.$confirm(
        '是否复制该条记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .shipmentPayStatementCopyApi({ shipmentPayStatementCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status, body } = res
        if (status !== 200) {
          this.$message.error(
            this.$l('INDEX.tips_tips_copy_error') || '复制失败！'
          )
          return
        }

        this.$message({
          showClose: true,
          message: this.$l('INDEX.btn_sure_copy_succeeded') || '复制成功',
          type: 'success',
        })
        this.$emit('reload')
        if (!body) return
        this.$emit('openEditPage', {
          pageType: 'edit',
          params: { code: body.shipmentPayStatementCode },
          query: { shipmentPayStatementNo: body.shipmentPayStatementNo },
        })
      })
    },
  },
}
</script>
